const install = (Vue) => {
  Vue.directive('shadowContainer', {
    bind(el, binding, vnode) {
      const newEl = document.createElement("div")
      newEl.classList.add('shadow-container')
      el.appendChild(newEl)
    }
  })
}

export default install

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
  if (install.installed) {
    install.installed = false
  }
}
